export function normalizeSchemaVersions(response) {
  const rawVersions = Array.isArray(response)
    ? response
    : response?.releaseVersions || response?.publishVersions || response?.versions || [];

  if (!Array.isArray(rawVersions)) return [];

  return [
    ...new Set(
      rawVersions
        .filter((version) => version != null)
        .map(String)
        .filter(Boolean)
    ),
  ].sort((a, b) => b.localeCompare(a, undefined, { numeric: true, sensitivity: 'base' }));
}
